// Listagem ordenada do registry para as superfícies de UI (modal Estudos e
// quem mais vier a listar indicadores). O registry é estático em runtime, então
// as listas são calculadas uma vez e cacheadas — referências estáveis, seguras
// para componentes memoizados. A ordem dos GRUPOS não é alterada aqui (decisão
// do board): só a ordem DENTRO de cada grupo, por nome exibido em pt-BR.
import indicatorRegistry from "./IndicatorRegistry";
import { silverlightOrigin } from "./silverlightOrigin";

const byDisplayName = (a, b) =>
  a.localeCompare(b, "pt-BR", { sensitivity: "base" });

const entriesCache = new Map();

/** Entradas [key, indicator] da categoria, ordenadas por displayName (pt-BR). */
export const sortedIndicatorEntries = (categoryKey) => {
  if (!entriesCache.has(categoryKey)) {
    const indicators = indicatorRegistry[categoryKey]?.indicators ?? {};
    entriesCache.set(
      categoryKey,
      Object.entries(indicators).sort(([, a], [, b]) =>
        byDisplayName(a.displayName, b.displayName),
      ),
    );
  }
  return entriesCache.get(categoryKey);
};

let silverlightListCache = null;

/**
 * Pseudo-grupo "Silverlight": os indicadores migrados do app legado, ordenados
 * por displayName. Cada item mantém a categoria REAL (é visão/atalho, não
 * recategorização) — o shape {categoryKey, indicatorKey, indicator} é o mesmo
 * do favoriteIndicatorList do modal Estudos.
 */
export const silverlightIndicatorList = () => {
  if (!silverlightListCache) {
    const list = [];
    for (const indicatorKey of Object.keys(silverlightOrigin)) {
      for (const categoryKey of Object.keys(indicatorRegistry)) {
        const indicator =
          indicatorRegistry[categoryKey].indicators[indicatorKey];
        if (indicator) {
          list.push({ categoryKey, indicatorKey, indicator });
          break;
        }
      }
    }
    list.sort((a, b) =>
      byDisplayName(a.indicator.displayName, b.indicator.displayName),
    );
    silverlightListCache = list;
  }
  return silverlightListCache;
};
